/* eslint-disable max-len */
import { useMutation } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import {
  CreateManualSalesOrderByBillingCycle,
  CreateManualSalesOrderByBillingCycleVariables,
} from '@/graphql/contracts/_generated_/createManualSalesOrderByBillingCycle.mutation';
import CreateManualSalesOrderByBillingCycleMutation from '@/graphql/contracts/createManualSalesOrderByBillingCycle.mutation.gql';
import { notificationService } from '@/services/notification/notification.client';
import { CreateManualSalesOrderByBillingCycleInputType } from '@/graphql/contracts/_generated_/contracts';

interface UseCreateManualSalesOrderOptions {
  onSuccess?: () => void;
}

export default function useCreateManualSalesOrderByBillingCycle(
  options?: UseCreateManualSalesOrderOptions
) {
  const [_createManualSalesOrder, { loading }] = useMutation<
  CreateManualSalesOrderByBillingCycle,
  CreateManualSalesOrderByBillingCycleVariables
  >(CreateManualSalesOrderByBillingCycleMutation, {
    client: apolloClientContracts,
    onError: (err) =>
      notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger',
      }),
    onCompleted: () => {
      notificationService.open({
        title: 'Sales Order Created',
        text: 'Manual sales order successfully created',
        type: 'success',
      });
      // Call onSuccess callback to trigger refetch
      options?.onSuccess?.();
    },
  });

  const createManualSalesOrderByBillingCycle = async (
    input: CreateManualSalesOrderByBillingCycleInputType
  ) => {
    const response = await _createManualSalesOrder({
      variables: { input },
    });

    return response.data?.createManualSalesOrderByBillingCycle;
  };

  return {
    createManualSalesOrderByBillingCycle,
    isLoadingCreateManualSalesOrder: loading,
  } as const;
}
